import 'bootstrap-daterangepicker/daterangepicker.css';
import classnames from 'classnames';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { DateRangePicker } from 'react-bootstrap-daterangepicker';
import { useDispatch, useSelector } from 'react-redux';
import {
  Button,
  ButtonGroup,
  Col,
  Container,
  Input,
  InputGroup,
  InputGroupAddon,
  Row,
  TabContent,
  TabPane,
} from 'reactstrap';
import {
  deleteFaxCancel,
  getAllPendingFaxes,
  getFaxesFailSummaryV2,
  getFaxesSummaryV2,
  sendFaxCancel,
  sendFaxShow,
  sendFax
} from '../../actions/Fax';
import Breadcrumbs from '../../components/Breadcrumb';
import CompanyAutocomplete from '../../components/CompanyAutocomplete';
import DeleteFaxModal from '../../components/DeleteFaxModal';
import FaxesReportTab from '../../components/FaxesReportTab';
import SendFaxModal from '../../components/SendFaxModal';
import Calendar from '../../Res/Icon/Calendar.png';
import filterIcon from '../../Res/Icon/filter.png';
import PendingFaxes from './PendingFaxes';
import ProcessedFaxes from './ProcessedFaxes';
import { toast } from 'react-toastify';
import utils from '../../lib/utils';
const tabEnum = {
  pending: 'pending',
  processed: 'processed',
  stat: 'stat',
};
const filterAttrMapping = {
  'By Sender Number': 'sender',
  'By Receiver Number': 'receiver',
  'By Box Serial Number': 'box',
  'By Caller id': 'sender',
  'By Destination Number': 'receiver',
};
const tabOptions = {
  pending: ['By Company', 'By Sender Number', 'By Receiver Number', 'By Box Serial Number'],
  processed: ['By Company', 'By Sender Number', 'By Receiver Number', 'By Box Serial Number'],
  stat: ['By Company', 'By Destination Number', 'By Caller id'],
};
const ranges = {
  Today: [moment(), moment()],
  Yesterday: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
  'Last 7 Days': [moment().subtract(6, 'days'), moment()],
  'Last 30 Days': [moment().subtract(29, 'days'), moment()],
  'This Month': [moment().startOf('month'), moment().endOf('month')],
  'Last Month': [
    moment()
      .subtract(1, 'month')
      .startOf('month'),
    moment()
      .subtract(1, 'month')
      .endOf('month'),
  ],
};
export default function () {
  const token = localStorage.getItem('jwtToken') || null;
  const user = useSelector(state => state.AppState.user);
  const filterState = {
    company:
      (user.role === 'admin' || user.role === 'enterpriseAdmin') && user.company?._id
        ? user.company._id
        : null,
    box: null,
    sender: '+1',
    receiver: '+1',
  };
  const companyFilter = useSelector(state => state.UIState.epikBoxes.companyFilter);
  const showDeleteFax = useSelector(state => state.UIState.faxes.deleteFaxShow);
  const showNewFax = useSelector(state => state.UIState.faxes.sendFaxShow);
  const companies = useSelector(state => state.AppState.companies);
  const [summary, setSummary] = useState({ faxes: [], failure: [] });
  const [tab, setTab] = useState(tabEnum.pending);
  const [state, setState] = useState({
    number: '',
    filter: '',
    date: [
      moment()
        .endOf('day')
        .toDate(),
      moment().subtract(6, 'days')._d,
    ],
    ...filterState,
    faxLoading: false
  });

  const faxNumbers = useSelector(state => state.UIState?.faxes?.sendFax?.numbers);
  const faxFiles = useSelector(state => state.UIState?.faxes?.sendFax?.files);
  const dispatch = useDispatch();

  useEffect(() => {
    if (tab === tabEnum.stat) getData();
  }, [state.date, state.company, state.receiver, state.sender, tab]);
  const getData = async () => {
    console.log({ cccccallledd: true });
    const faxes = await dispatch(
      getFaxesSummaryV2(token, {
        to: moment(date[0]).format('YYYY-MM-DDTHH:mm:ss.SSS'),
        from: moment(date[1]).format('YYYY-MM-DD'),
        company: state.company,
        sender: state.sender,
        receiver: state.receiver,
      }),
    );
    const failure = await dispatch(
      getFaxesFailSummaryV2(token, {
        to: date[0],
        from: date[1],
        company: state.company,
        sender: state.sender,
        receiver: state.receiver,
      }),
    );

    setSummary({ faxes: faxes || [], failure: failure || [] });
  };
  const onStateChange = (value, key) => {
    console.log({ value, key });
    setState(state => ({ ...state, [key]: value }));
  };

  useEffect(() => {
    if (tab) {
      onStateChange(tabOptions[tab][0], 'filter');
    }
  }, [tab]);
  useEffect(() => {
    setState(s => ({ ...s, ...filterState }));
  }, [state.filter]);
  const handeleClick = e => {
    const el = document.querySelector('.daterangepicker');
    el.classList.toggle('show-dp');
  };
  const onApply = (e, piker) => {
    const dataEnd = piker.endDate._d;
    const dataStart = piker.startDate._d;
    onStateChange([dataEnd, dataStart], 'date');
  };

  const onSendFax = async () => {
    if (faxNumbers.length && faxFiles.length) {
      console.log('faxData is ', faxNumbers, faxFiles);
      const faxData = new FormData()
      faxFiles.map(file => faxData.append('file', file))
      faxData.append('receiver', faxNumbers)
      setState(pre => ({
        ...pre,
        faxLoading: true
      }))
      await dispatch(sendFax(token, faxData));

      setTimeout(() => {
        setState(pre => ({
          ...pre,
          faxLoading: false
        }))
      }, 100)
    } else {
      toast.error('Number and file is required')
    }
  }

  const { filter, date, company, box, receiver, sender } = state;
  const allowedNewFaxRoles = ['user', 'admin', 'companyGroupAdmin', 'enterpriseAdmin', 'superAdmin'];
  return (
    <div>
      <div className="filter-section">
        <Row>
          {/* <Col md={3} sm={12}>
            <Breadcrumbs />
          </Col> */}
          <Col md={12} sm={12}>
            <Row className="align-items-center justify-content-end">
              {allowedNewFaxRoles.includes(user.role) && (
                  <Col md={2}>
                    <Button
                      color="primary"
                      className="float-right"
                      onClick={() => dispatch(sendFaxShow())}
                      disabled={user.readOnly}
                    >
                      New Fax
                    </Button>
                  </Col>
                )}

              <Col md={{ size: 4 }} style={{ display: 'flex' }}>
                <InputGroup>
                  <InputGroupAddon addonType="prepend" className="filter-icon-div">
                    <img src={filterIcon} className="filter-icon" alt="..." />
                  </InputGroupAddon>

                  <Input
                    type="select"
                    className="filter-append-dropdown"
                    onChange={e => onStateChange(e.currentTarget.value, 'filter')}
                    value={filter}
                  >
                    {tabOptions[tab].map(el => (
                      <option key={el} value={el}>
                        {el}
                      </option>
                    ))}
                  </Input>
                </InputGroup>
                {[
                  'superAdmin',
                  'supportEngineer',
                  'companyGroupAdmin',
                  'companyGroupManager',
                ].includes(user.role) ? (
                  filter === 'By Company' ? (
                    companies.docs && (
                      <CompanyAutocomplete
                        searchTerm={companyFilter.value}
                        placeholder="Filter Company..."
                        companies={companies.docs}
                        onChange={data => onStateChange(data.suggestion?._id || null, 'company')}
                      />
                    )
                  ) : (
                    <Input
                      type="text"
                      value={state[filterAttrMapping[filter]] || ''}
                      placeholder={`Filter ${filter}`}
                      onChange={e => onStateChange(e.target.value, filterAttrMapping[filter])}
                    />
                  )
                ) : (
                  <Input
                    type="text"
                    value={state[filterAttrMapping[filter]] || ''}
                    placeholder={`Filter ${filter}`}
                    onChange={e => onStateChange(e.target.value, filterAttrMapping[filter])}
                  />
                )}
              </Col>
              {tab != 'pending' && (
                <Col md={{ size: 4 }}>
                  <DateRangePicker
                    autoUpdateInput
                    startDate={
                      date[1] ||
                      moment()
                        .startOf('day')
                        .toDate()
                    }
                    endDate={
                      date[0] ||
                      moment()
                        .endOf('day')
                        .toDate()
                    }
                    onApply={onApply}
                    showCustomRangeLabel
                    alwaysShowCalendars
                    ranges={ranges}
                    opens="left"
                    onHide={handeleClick}
                    onShow={handeleClick}
                  >
                    <div className="input-group" style={{ alignItems: 'center' }}>
                      <span className="input-group-btn">
                        <Button
                          className="default date-range-toggle"
                          style={{
                            background: '#DDE6FA',
                            border: 'none',
                            color: '#FF2437',
                            width: '4rem',
                          }}
                        >
                          <img style={{ width: '50%' }} src={Calendar} alt="..."></img>
                        </Button>
                      </span>
                      <div className="view-data-input">
                        {utils.getDateTimeFormat(date[1], 'regular')} -{' '}
                        {utils.getDateTimeFormat(date[0], 'regular')}
                      </div>
                    </div>
                  </DateRangePicker>
                </Col>
              )}
            </Row>
          </Col>
        </Row>
      </div>

      <Container fluid style={{ margin: 0 }}>
        <div className="viewContainer" style={{ marginTop: '20px' }}>
          <ButtonGroup className="tab-group">
            <Button
              className={classnames({ active: tab === tabEnum.pending })}
              onClick={() => {
                setTab(tabEnum.pending);
              }}
            >
              Pending
            </Button>

            <Button
              className={classnames({
                active: tab === tabEnum.processed,
              })}
              onClick={() => {
                setTab(tabEnum.processed);
              }}
            >
              Processed
            </Button>

            <Button
              className={classnames({
                active: tab === tabEnum.stat,
              })}
              onClick={() => {
                setTab(tabEnum.stat);
              }}
            >
              Stats
            </Button>
          </ButtonGroup>
          <Row>
            {
              <Col md="12">
                <TabContent activeTab={tab}>
                  <TabPane tabId={tabEnum.pending}>
                    {tab === tabEnum.pending && (
                      <PendingFaxes
                        filterValues={{
                          company,
                          box,
                          sender: sender === '+1' ? null : sender,
                          receiver: receiver === '+1' ? null : receiver,
                        }}
                      />
                    )}
                  </TabPane>
                  <TabPane tabId={tabEnum.processed}>
                    {tab === tabEnum.processed && (
                      <ProcessedFaxes
                        filterValues={{
                          company,
                          box,
                          sender: sender === '+1' ? null : sender,
                          receiver: receiver === '+1' ? null : receiver,
                          to: state.date[0],
                          from: state.date[1],
                        }}
                      />
                    )}
                  </TabPane>
                  <TabPane tabId={tabEnum.stat}>
                    {tab === tabEnum.stat && (
                      <FaxesReportTab faxes={summary.faxes} failure={summary.failure} />
                    )}
                  </TabPane>
                </TabContent>
              </Col>
            }
          </Row>
        </div>
        <DeleteFaxModal
          isOpen={showDeleteFax}
          onCancel={() => dispatch(deleteFaxCancel())}
          onConfirm={data => console.log(data)}
        />
        <SendFaxModal
          isOpen={showNewFax}
          onCancel={() => dispatch(sendFaxCancel())}
          onConfirm={data => {
            onSendFax()
          }}
          onSendFax={data => console.log(data)}
          loading={state.faxLoading}
        />
      </Container>
    </div>
  );
}
